/**
 * MLO Search - "Load More" results
 * Shows the MLO cards in batches (default 4) and reveals the next batch
 * each time the "Load More" button is clicked.
 */
export function mloSearch() {

    const BATCH = 4;

    $('.mlo-results').each(function() {
        const $block = $(this);
        const $cards = $block.find('.card.mlo');
        const $loadMore = $block.find('.js-load-more');

        //Only wire up blocks that actually have cards and a Load More button.
        if (!$cards.length || !$loadMore.length) {
            return;
        }

        let shown = BATCH;

        //Hide every card past the first batch.
        $cards.slice(BATCH).addClass('mlo-card-hidden');

        //Nothing left to load — hide the button entirely.
        if ($cards.length <= BATCH) {
            $loadMore.parent().hide();
        }

        $loadMore.on('click', function(e) {
            e.preventDefault();
            const $next = $cards.slice(shown, shown + BATCH);

            //The stagger animation delays by nth-child * 0.15s, so later cards
            //would otherwise wait 1s+ before fading in. Override with a small,
            //uniform per-batch stagger so revealed cards appear quickly.
            $next.each(function(i) {
                this.style.animationDelay = (i * 0.08) + 's';
            });

            $next.removeClass('mlo-card-hidden');
            shown += BATCH;
            if (shown >= $cards.length) {
                $loadMore.parent().hide();
            }
        });
    });
}
